import { render, staticRenderFns } from "./PurchasesList.vue?vue&type=template&id=1def04b6&scoped=true&lang=pug&"
import script from "./PurchasesList.vue?vue&type=script&lang=js&"
export * from "./PurchasesList.vue?vue&type=script&lang=js&"
import style0 from "./PurchasesList.vue?vue&type=style&index=0&id=1def04b6&prod&lang=sass&scoped=true&"
import style1 from "./PurchasesList.vue?vue&type=style&index=1&id=1def04b6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1def04b6",
  null
  
)

/* custom blocks */
import block0 from "./PurchasesList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports